var map = {
	"./002.png": "f857",
	"./banner10.png": "ade8",
	"./banner9.png": "7ff3",
	"./bg.png": "d68e",
	"./end.png": "94ec",
	"./ing.png": "cd4e",
	"./jinpai.png": "2e72",
	"./logo.png": "cf05",
	"./logob.png": "2386",
	"./logot.png": "3f0f",
	"./newBg.png": "1bc7",
	"./pLogo.png": "4a78",
	"./paihang.png": "b92b",
	"./start.png": "fd98",
	"./swip.png": "506d",
	"./test.png": "1552",
	"./tongpai.png": "03b3",
	"./xin.png": "8e14",
	"./yinpai.png": "7297"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";